// Sketcher.jsx
import DesignerList from "./DesignerList";

export default function Sketcher() {
  return <DesignerList type="sketcher" />;
}
